import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Redirect } from "react-router-dom";
import {
  Button,
  FormLabel
} from "@material-ui/core";
import { EMPADRONAMIENTO_MEDICACION_ESTADOS, STEPPER_MEDICACION } from "../../../utils/constants";
import { confirmarSolicitudMedicacion, setActiveStep } from "../../../actions/empadronamiento/Empadronamiento";
import AlertaMail from "../UI/AlertaMail";
import { MedicacionCard } from "../UI/MedicacionCard";
import { MEDICACION_MENU_PERMISOS } from "../../../utils/permisos";
import { validarSoloUnPermiso } from "../../../helpers/permisos";

export const MedicacionConfirmacion = () => {
  const dispatch = useDispatch();

  const { solicitudSeleccionada = {} } = useSelector((state) => state.empadronamiento);
  const [open, setOpen] = useState(false);
  const { permisos: permisosUser } = useSelector((state) => state.auth);

  let idSolicitud = 0;
  let idEstadoSolicitud = 0;

  if (!!solicitudSeleccionada) {
    idSolicitud = solicitudSeleccionada?.idSolicitud;
    idEstadoSolicitud = solicitudSeleccionada?.idEstadoSolicitud;
  }

  const imprimirPDF = "imprimirPDF";
  const [redirect, setRedirect] = useState(false);

  const mensaje = "El email se enviará a la casilla " + solicitudSeleccionada.afiliado?.domiciliosAfiliados?.mail + " ¿Desea continuar?";

  /*
  const onConfirmHandler = () => {
    const imprimir = imprimirPDF === "imprimirPDF";
    if (imprimir === null) {
      dispatch(startAlerta(`Seleccione que desea hacer con la solicitud.`, "error"));
    } else {
      if (idSolicitud !== 0) {
        dispatch(confirmarSolicitudMedicacion(idSolicitud,
          imprimir,
          (idEstadoSolicitud === EMPADRONAMIENTO_MEDICACION_ESTADOS.PENDIENTE_AUTORIZACION ||
            validarSoloUnPermiso(
              permisosUser,
              MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
            ) || validarSoloUnPermiso(
              permisosUser,
              MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_DISCA
            )),
          setRedirect,
          validarSoloUnPermiso(
            permisosUser,
            MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
          ),
          validarSoloUnPermiso(
            permisosUser,
            MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
          ),
          validarSoloUnPermiso(
            permisosUser,
            MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_DISCA
          )));
      } else {
        dispatch(startAlerta(`No se encontro la solicitud.`, "error"));
      }
    }
  };

  const onClickConfirmarHandler = () => {
    if ((idEstadoSolicitud === EMPADRONAMIENTO_MEDICACION_ESTADOS.PENDIENTE_AUTORIZACION ||
      (validarSoloUnPermiso(
        permisosUser,
        MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
      ) || validarSoloUnPermiso(
        permisosUser,
        MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_DISCA
      )))
      && imprimirPDF !== "imprimirPDF") {
      setOpen(true);
    } else {
      onConfirmHandler();
    }
  };
  */


  const onConfirmHandler = () => {
    dispatch(confirmarSolicitudMedicacion(idSolicitud,
      EMPADRONAMIENTO_MEDICACION_ESTADOS.PENDIENTE_REVISION,
      setRedirect
    ));
  };

  const onClickConfirmarHandler = () => {
    onConfirmHandler();
  };

  return (
    <MedicacionCard width={"55%"}>
      <div
        style={{ display: "flex", justifyContent: "center" }}
      >
        <FormLabel
          style={{
            fontSize: "1.2rem",
            marginTop: "1.5rem",
            fontWeight: "bold"
          }}
        >
          Una vez confirmada, la solicitud se pasará a la bandeja de Revisión.
        </FormLabel>
      </div>
      <div
        style={{ display: "flex", justifyContent: "center", margin: "2rem" }}
      >
        <Button
          variant="contained"
          color="secondary"
          style={{ marginRight: "3rem" }}
          onClick={() => {
            dispatch(setActiveStep(STEPPER_MEDICACION.MEDICAMENTOS));
          }}
        >
          Anterior
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onClickConfirmarHandler}
        >
          Confirmar
        </Button>
      </div>
      {redirect && (
        <Redirect
          to={{
            pathname: "/medicacion",
          }}
        />
      )}
      {(idEstadoSolicitud === EMPADRONAMIENTO_MEDICACION_ESTADOS.PENDIENTE_AUTORIZACION ||
        (validarSoloUnPermiso(
          permisosUser,
          MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
        ) || validarSoloUnPermiso(
          permisosUser,
          MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_DISCA
        )))
        && (imprimirPDF !== "imprimirPDF")
        &&
        <AlertaMail
          open={open}
          setOpen={setOpen}
          mensaje={mensaje}
          handleDecisionYes={onConfirmHandler}
          handleDecisionNo={onConfirmHandler}
        />}
    </MedicacionCard>
  );
};
